import type { AgentDashboardStats, DashboardStats } from "@/types/dashboard";
import { apiClient } from "./client";

export const dashboardApi = {
  getStats() {
    return apiClient.get<DashboardStats>("/admin/dashboard/stats");
  },

  getAgentStats() {
    return apiClient.get<AgentDashboardStats>("/settings/dashboard");
  },
};
